/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TGenericBlueprintSchema } from "@adapptio/lib-blueprint";
import { ILogger } from "../logger";
import { createSessionStorageFactory } from "./createSessionStorageFactory";
import { ISessionStorage, ISessionStorageOptions } from "./ISessionStorage";
import { ISessionStorageDefinition } from "./ISessionStorageDefinition";

/**
 * Creates Session Storage definition
 */
export function createSessionStorageDefinition<
	TStorageOptions extends ISessionStorageOptions,
	TClass extends ISessionStorage
>(
	name: string,
	category: string,
	label: string,
	optionsSchema: TGenericBlueprintSchema,
	entityClass: new (config: TStorageOptions, logger: ILogger) => TClass
): ISessionStorageDefinition<TStorageOptions, TClass> {
	return {
		name,
		category,
		label,
		factory: createSessionStorageFactory(entityClass),
		optionsSchema
	};
}
